import { useRepositoryQuery } from '@mews-commander/data-access';

export const useFetchKeyCuttersQuery = () =>
    useRepositoryQuery(
        'keyCutters',
        'getAll',
        {},
        {
            staleTime: 4 * 60 * 60 * 1000,
        }
    );
